// Source Sans 3 is the first import in the file, ahead of both stylesheets, so its
// `@font-face` declarations are registered before any rule that names the family. The
// component library declares the stack in `--font-family-base` but deliberately ships
// no font bytes, leaving the face to the consuming app; without this import the token
// falls through Source Sans 3 to `system-ui` and nothing renders in the design's
// typeface. Mirrors arc's `main.tsx` (RND-12969).
import '@fontsource-variable/source-sans-3'
import './index.css'
import '@rgrd/component-library/style.css'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App'
import { Auth0ProviderWithConfig } from './auth/Auth0ProviderWithConfig'
import { type RuntimeConfig, setRuntimeConfig } from './config'
import { setRegardWindowValue } from '~/shared/window'

// Build version, injected as an environment variable during bundling (see the
// Dockerfile's VITE_APP_VERSION). Exposed on window for traceability in deployed images.
setRegardWindowValue('version', import.meta.env.VITE_APP_VERSION)

async function loadConfig(): Promise<RuntimeConfig> {
  const resp = await fetch('/config.json')
  if (!resp.ok) {
    throw new Error(`Failed to load config.json: ${resp.status}`)
  }
  return resp.json()
}

async function main() {
  const config = await loadConfig()
  setRuntimeConfig(config)

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <Auth0ProviderWithConfig>
        <App />
      </Auth0ProviderWithConfig>
    </StrictMode>,
  )
}

main()
